import React, { Dispatch } from 'react';
import Translator from '../../../../core/i18n';
import { Log } from 'ng2-logger';
import Moment from 'moment';
import ProcessingActivity from '../activity-proccessing/processing-activity';
import { Common } from '../../../../core/common';
import { ISignleActivityCard } from '../../../../models/components/single-activity-card';
import { UserType } from '../../../../models/pages/login.d';
import { Notification } from '../../../../components/notification/main';
import { connect } from 'react-redux';
import { IAppState, IAction } from '../../../../models/action/core';
import { CompletionType } from '../../../../models/enums/CompletionType';
import { enrollmentSetState } from '../../../../store/actions/enrollment';
import ProgressCircle from '../../../progress-circle/progress-circle';
import { SecurityContextType, SecurityPermissionType } from '../../../../core/SecurityContext';
import { getCourseContentsWeekActivitiesAction, SetUpdateInput } from '../../../../store/actions/coursePage';
import EdiText from 'react-editext';
import { Formik, FormikActions, FormikProps } from 'formik';
import { SurveyQuestionType } from '../../../../models/enums/SurveyQuestionType';
import CSurveyQuestionsModal from './modal';
import { IResponseData } from '../../../../models/components/activity-card-survey';
import { responseSurvey } from '../../../../store/actions/survey';
import CCard from './card';
import { activityTypeSetAction } from '../../../../store/actions/core';
import { IEnrollmentData } from '../../../../models/action/enrollment';
import { CoursePageService } from '../../../../api/course-page-service';
import { IActivityCard } from '../../../../models/components/activity-card';
import * as Actions from '../../../../store/actions/coursePage';
import { SurveyType } from '../../../../models/enums/SurveyType';
import ReactGA from 'react-ga4';
import ProgressCircleStudent from '../../../progress-circle/progress-circle-student';
import { enrollmentStatus } from '../../../../models/enums/enrollmentStatus';
import Tooltip from '../../../tooltip/main';
import { validateSurveyResponses } from '../../../../helpers/surveyHelpers';
const _logger = Log.create('Survey Card');
const maxEditTextLength = 65;
const T = Translator.create();
let _common: Common;
let getActivityId: string;
const coursePageService = new CoursePageService();

interface ISurveyActivityCardState {
    isModalOpen: boolean;
    isSubmitting: boolean;
    nowDate: string;
    editTextValue: string;
    editTextHandleValue: string;
    nonWeeklyCourse?: boolean | null;
}
class SurveyActivityCard extends React.Component<ISignleActivityCard, ISurveyActivityCardState> {
    constructor(props: any) {
        super(props);
        _common = new Common();
        Moment.locale(T.i18next.language);
        getActivityId = this.props.activityCard!.activityId!;

        this.state = {
            isModalOpen: false,
            isSubmitting: false,
            nowDate: Moment(this.props.activityCard!.serverDate).add(-1, 'minute').format('yyyy-MM-DDTHH:mm:ss'),
            editTextValue:
                this.props.activityCard!.name!.toString().length > maxEditTextLength
                    ? this.props.activityCard!.name!.slice(0, maxEditTextLength).toString() + '...'
                    : this.props.activityCard!.name!.toString(),
            editTextHandleValue: this.props.activityCard!.name!.toString(),
            nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1
        };

        this.onSubmit.bind(this);
        this.afterSave = this.afterSave.bind(this);
    }

    public componentDidMount(): void {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    componentDidUpdate(prevProps: Readonly<ISignleActivityCard>, prevState: Readonly<{}>, snapshot?: any): void {
        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1) {
            this.setState({ nonWeeklyCourse: true })
        }
    }

    afterSave() {
        this.props.dispatch(getCourseContentsWeekActivitiesAction(
            this.props.classId ? this.props.classId : '0',
            this.props.coursePageActivityId ? this.props.coursePageActivityId : '0',
            this.props.weekOrUnitId !== '0',
            0,
            1000,
            this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
            false,
            false,
            null,
            'contentWeekActivities',
            'get', undefined, this.props.sortKey ?? "-"));
    }

    public handleSave = (name: any) => {
        if (this.props.activityCard?.activityId && this.props.activityCard?.name !== name) {
            this.props.dispatch(
                SetUpdateInput(this.props.activityCard.activityId, name, 'api/activity/updateActivityName', 'POST', this.props.classId!, this.afterSave)
            );
            this.setState({
                editTextValue: name.length > maxEditTextLength
                    ? name.slice(0, maxEditTextLength).toString() + '...'
                    : name.toString(), editTextHandleValue: name
            });
        }
    };

    public handleClick(value: string) {
        this.setState({ editTextValue: value });
    };

    callBackFunc = (value: any, formikActions: any) => {
        if (value) {
            formikActions.setFieldValue('isResponded', true);
            this.triggerModal();
            const enrollmentData: IEnrollmentData[] = [
                {
                    activityId: this.props.activityCard!.activityId!,
                    enrollmentId: this.props.activityCard!.enrollmentId ? this.props.activityCard!.enrollmentId : value,
                    progress: 100,
                    status: 2,
                    userId: this.props.identity.userId,
                    completionCriteria: 0,
                    completionType: CompletionType.Complete,
                    completionDate: new Date(),
                    score: 0,
                    statusText: '',
                    totalSeconds: 0,
                    virtualClassLiveProgress: 0,
                    virtualClassReplayProgress: 0,
                    replaySeconds: 0,
                    uploadCount: 0,
                    isRefresh: true
                }
            ];
            this.props.dispatch(enrollmentSetState(enrollmentData));

        }
        this.setState({ isSubmitting: false });
    }

    onSubmitSucced = (values: any, formikActions: any) => {
        if (
            this.props.activityCard?.surveyInfo?.surveyInfoId &&
            this.props.classId &&
            this.props.activityCard.activityId
        ) {
            this.setState({ isSubmitting: true });
            this.props.dispatch(
                responseSurvey(
                    values.userResponses,
                    this.props.activityCard.surveyInfo.surveyInfoId,
                    SecurityContextType.None,
                    '',
                    this.props.activityCard.activityId,
                    this.props.classId,
                    this.props.activityCard.enrollmentId!,
                    SurveyType.Activity,
                    (value: any) => this.callBackFunc(value, formikActions)
                )
            );
        }
    }

    onSubmit = (values: IResponseData, formikActions: FormikActions<IResponseData>) => {
        const { surveyInfo } = this.props.activityCard!;
        const { userResponses } = values;

        const isError = validateSurveyResponses(surveyInfo, userResponses);

        if (isError) {
            Notification.setNotification('error', T.t('r_survey_unresponded_questions_error'), 'topRight');
        } else {            
            this.onSubmitSucced(values, formikActions);
        }
    };


    triggerModal = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_VIEW_SURVEY_CLICKED',
            label: 'G_VIEW_SURVEY_CLICKED',
            nonInteraction: true,
        });
        this.setState((prevState: any) => ({ isModalOpen: !prevState.isModalOpen }));
    };

    onChangeQuestion = (type: 'previous' | 'next', formik: FormikProps<IResponseData>) => {
        if (type === 'next') {
            formik.setFieldValue('questionIndex', formik.values.questionIndex + 1);
        } else if (type === 'previous') {
            formik.setFieldValue('questionIndex', formik.values.questionIndex - 1);
        }
    };

    SetActive = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_ACTIVATE_SURVEY_CLICKED',
            label: 'G_ACTIVATE_SURVEY_CLICKED',
            nonInteraction: true,
        });
        if (
            this.props.activityCard!.surveyInfo &&
            this.props.activityCard!.surveyInfo.questionList &&
            this.props.activityCard!.surveyInfo.questionList.length
        ) {
            this.props.dispatch(activityTypeSetAction(this.props.activityCard!.activityType!, this.props.activityCard!.activityId!));
        } else {
            Notification.setNotification('info', T.t('r_survey_active_error'), 'topRight');
        }
    };

    renderCardHeader = () => {
        let enrollmentData = this.props.enrollmentData!.filter(enr => enr.activityId === this.props.activityCard!.activityId);
        let enrollmentDataStatus = enrollmentData.length > 0 ? enrollmentData[0].status : enrollmentStatus.NotStarted
        let activityEnrollmentStatus = this.props.activityCard!.enrollmentStatus ? this.props.activityCard!.enrollmentStatus
            : enrollmentDataStatus;

        let activityDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : null;

        return (
            <div className="card-header">
                <div className={"activity-title " + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? 'arabic-text-card' : '')}>
                    <img src={_common.GetActivityTypeIcons('survey')} alt='surveyIcon' />
                    <span className='activity-name'>
                        {Common.HasPermission(
                            SecurityContextType.Class,
                            SecurityPermissionType.Activity_Add,
                            this.props.classId!
                        ) ? (
                            <div title={this.props.activityCard!.name} className="visible">
                                <EdiText
                                    type="text"
                                    onSave={this.handleSave}
                                    onCancel={event => this.handleClick(this.state.editTextValue.length > maxEditTextLength
                                        ? this.state.editTextValue.slice(0, maxEditTextLength).toString() + '...'
                                        : this.state.editTextValue.toString())}
                                    onEditingStart={event => this.handleClick(this.state.editTextHandleValue)}
                                    value={this.state.editTextValue}
                                    showButtonsOnHover={true}
                                    saveButtonClassName="hideEditextSaveButton"
                                    cancelButtonClassName="hideEditextCancelButton"
                                    validationMessage={T.t('r_forum_tree_character')}
                                    // tslint:disable-next-line:jsx-no-lambda
                                    validation={val => val.trim().length >= 3}
                                    editOnViewClick={true}
                                    submitOnEnter={true}
                                    cancelOnEscape={true}
                                    className={'font-weight-bold mobile-activity-title web-activity-title' + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')}
                                    tabIndex={0}
                                />
                            </div>
                        ) : (
                            <div title={this.props.activityCard!.name} tabIndex={0} className={"visible mobile-activity-title web-activity-title" + (!_common.isArabic(this.state.editTextValue, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ cursor: 'pointer', lineHeight: 1.3, whiteSpace: 'pre-line', textOverflow: 'ellipsis' }}>{this.props.activityCard!.name}</div>
                        )}
                    </span>

                    <ProcessingActivity
                        externalCssClassName="ml-auto show_on_mobile"
                        activityId={this.props.activityCard!.activityId}
                        activityType={this.props.activityCard!.activityType}
                    />

                </div>
                <div className="activity-status">
                    {this.props.activityCard?.alwaysOnTop ? <span className="pinned"></span> : ''}
                    <span className="badges badges-survey activity-type">{T.t('r_activity_type_Survey')}</span>
                    {/* <h6 style={{ margin: 'auto' }}>{this.props.activityCard?.alwaysOnTop ? '📍' : ''}</h6> */}
                    {this.props.activityCard!.taskDeadLine ? (
                        <div className="last-date mr-2" data-toggle="tooltip" data-placement="top" title={T.t('r_activity_deadline')}>
                            <Tooltip data={T.t('r_activity_deadline') + ': ' + Moment(this.props.activityCard!.taskDeadLine).format(
                                _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 3)
                            )} position='top' >
                                <span>
                                    <i className="material-icons mr-1 text-warning">calendar_today</i>
                                </span>
                            </Tooltip>
                        </div>
                    ) : (
                        ''
                    )}
                    {this.props.userType === UserType.Student ? (
                        <ProgressCircleStudent enrollmentStatus={activityEnrollmentStatus ?? enrollmentStatus.NotStarted} deadline={activityDeadline} activityCard={this.props.activityCard} />
                    ) : (
                        <ProgressCircle
                            activityCard={this.props.activityCard}
                            percent={
                                this.props.activityCard!.completedUser === 0
                                    ? 0
                                    : (this.props.activityCard!.completedUser! * 100) / this.props.activityCard!.totalEnrollUser!
                            }
                        />
                    )}
                    {this.props.userType !== UserType.Student ? (
                        <ProcessingActivity
                            externalCssClassName="hide_on_mobile"
                            activityId={this.props.activityCard!.activityId}
                            activityType={this.props.activityCard!.activityType}
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        )
    }

    checkPrerequisite = () => {
        let isPrerequisiteCompleted = false
        if (this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student) {
            if (this.props.enrollmentData) {
                let prerequisiteActivities = this.props.enrollmentData.filter(f => f.activityId === this.props.activityCard!.prerequisiteActivityId)
                if (prerequisiteActivities.length > 0) {
                    if (prerequisiteActivities[0].status === enrollmentStatus.Completed && this.props.userType === UserType.Student) {
                        isPrerequisiteCompleted = true;

                    }
                }

            }
        }
        return isPrerequisiteCompleted;
    }

    renderSurveyButtons = (title: string, onClickFunc: any) => {
        return (
            <div className="aqua-container">
                <button type="button" style={{ cursor: 'default' }} onClick={onClickFunc} className="big-success-btn" tabIndex={0}>
                    {title}
                </button>
            </div>
        )
    }

    renderQuestionListWithoutModal = (formik: any) => {
        return (
            this.props.activityCard!.surveyInfo!.questionList &&
                this.props.activityCard!.surveyInfo!.questionList.length > 0 ? (
                <CCard formik={formik} questionList={this.props.activityCard!.surveyInfo!.questionList} />
            ) : (
                this.renderSurveyButtons(T.t('r_survey_no_question'), null)
            )
        )
    }

    renderSurveyCompleted = (isPreview: boolean, formik: any) => {
        return (
            this.props.activityCard!.surveyInfo?.questionList && !isPreview &&
                formik.values.questionIndex + 1 === this.props.activityCard!.surveyInfo?.questionList.length ? (
                <button
                    onClick={this.onSubmit.bind(this, formik.values, formik)}
                    className="success-btn-outline"
                    disabled={this.state.isSubmitting}
                >
                    {T.t('r_survey_complete')}
                </button>
            ) : (
                ''
            )
        )
    }

    renderSurveyNextQuestion = (formik: any) => {
        return (
            this.props.activityCard!.surveyInfo?.questionList && (formik.values.questionIndex + 1 < this.props.activityCard!.surveyInfo?.questionList.length) ? (
                <button
                    onClick={this.onChangeQuestion.bind(this, 'next', formik)}
                    className="success-btn"
                >
                    {T.t('r_survey_next_question')}
                </button>
            ) : (
                ''
            )
        )
    }

    renderSurveyPrevQuestion = (formik: any) => {
        return (
            this.props.activityCard!.surveyInfo?.questionList && formik.values.questionIndex > 0 &&
                formik.values.questionIndex < this.props.activityCard!.surveyInfo?.questionList.length ? (
                <button
                    onClick={this.onChangeQuestion.bind(this, 'previous', formik)}
                    className="success-btn mr-3"
                >
                    {T.t('r_survey_previous_question')}
                </button>
            ) : (
                ''
            )
        )
    }

    renderQuestions = (formik: any) => {

        let content;
        let taskDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : ''
        let isDeadlinePassed = new Date(this.state.nowDate).getTime() >= new Date(taskDeadline).getTime();
        const isModal =
            this.props.activityCard!.surveyInfo && this.props.activityCard!.surveyInfo.questionList
                ? this.props.activityCard!.surveyInfo.questionList.findIndex(q => q.questionType === SurveyQuestionType.Matrix) !== -1 ||
                this.props
                    .activityCard!.surveyInfo.questionList.filter(q => q.questionChoices)
                    .findIndex(q => q.questionChoices!.length >= 8) !== -1
                : false;

        let isPreview = this.props.userType !== UserType.Student;
        if (this.props.activityCard!.surveyInfo) {
            let matrixIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.Matrix)
            let singleChoiceIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.SingleChoice)
            let multipleChoiceIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.MultipleChoice)
            let openEndedIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.OpenEndedOneLine)
            let openEndTextAreaIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.OpenEndedTextArea)
            if (matrixIndex === -1 && singleChoiceIndex === -1 && multipleChoiceIndex === -1 && openEndedIndex === -1 && openEndTextAreaIndex === -1) {
                isPreview = true;
            }
        }
        let doesSurveyHasQuestion = this.props.activityCard!.surveyInfo?.questionList && this.props.activityCard!.surveyInfo.questionList.length > 0
        if ((this.props.identity.userType !== UserType.Student || (this.props.identity.userType === UserType.Student && !formik.values.isResponded && !(isDeadlinePassed))) &&
            !isModal && doesSurveyHasQuestion) {
            content = <><hr className="bottom-border-2 mobile-not-show" style={{ margin: '0em 1.5em' }} /><div className="card-footer mt-2">
                <div className="row justify-content-end">
                    {this.renderSurveyPrevQuestion(formik)}

                    {this.renderSurveyNextQuestion(formik)}

                    {this.renderSurveyCompleted(isPreview, formik)}
                </div>
            </div></>
        }
        else {
            content = '';
        }
        return content;
    }

    renderFooter = (formik: any) => {
        let footerContent;
        if (this.props.activityCard!.activeStatus === 0) {
            footerContent = <div className="card-footer">
                <div className="row gradient-btn-bg">
                    <a className="d-flex align-items-center pasif-btn" href="#">
                        {T.t('r_activity_status_passive')}
                    </a>
                    <button className="success-btn" onClick={this.SetActive}>
                        {T.t('r_activity_set_status_active')}
                    </button>
                </div>
            </div>
        }
        else {
            footerContent = this.renderQuestions(formik)
        }
        return footerContent;
    }

    renderSurveyContent = (formik: any) => {
        let content;
        let taskDeadline = this.props.activityCard!.taskDeadLine ? this.props.activityCard!.taskDeadLine : ''
        let isDeadlinePassed = new Date(this.state.nowDate).getTime() >= new Date(taskDeadline).getTime();
        const isModal =
            this.props.activityCard!.surveyInfo && this.props.activityCard!.surveyInfo.questionList
                ? this.props.activityCard!.surveyInfo.questionList.findIndex(q => q.questionType === SurveyQuestionType.Matrix) !== -1 ||
                this.props
                    .activityCard!.surveyInfo.questionList.filter(q => q.questionChoices)
                    .findIndex(q => q.questionChoices!.length >= 8) !== -1
                : false;

        let isPreview = this.props.userType !== UserType.Student;
        if (this.props.activityCard!.surveyInfo) {
            let matrixIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.Matrix)
            let singleChoiceIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.SingleChoice)
            let multipleChoiceIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.MultipleChoice)
            let openEndedIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.OpenEndedOneLine)
            let openEndTextAreaIndex = this.props.activityCard!.surveyInfo.questionList!.findIndex(q => q.questionType === SurveyQuestionType.OpenEndedTextArea)
            if (matrixIndex === -1 && singleChoiceIndex === -1 && multipleChoiceIndex === -1 && openEndedIndex === -1 && openEndTextAreaIndex === -1) {
                isPreview = true;
            }
        }

        if (this.props.userType === UserType.Student && !formik.values.isResponded && isDeadlinePassed) {
            content = <div className="row mobile-survey-completed-date">
                {this.renderSurveyButtons(T.t('r_survey_deadline_error'), this.triggerModal)}
            </div>
        }
        else if (formik.values.isResponded && this.props.userType === UserType.Student) {
            content = this.renderSurveyButtons(T.t('r_survey_complete_info'), null)
        }
        else if (isModal) {
            content = <div className="row">
                {this.renderSurveyButtons(T.t('r_survey_show'), this.triggerModal)}
                <CSurveyQuestionsModal
                    isModalOpen={this.state.isModalOpen}
                    triggerModal={this.triggerModal}
                    isPreview={isPreview}
                    questionList={this.props.activityCard!.surveyInfo!.questionList}
                    surveyName={this.props.activityCard!.name}
                    formik={formik}
                    onSubmit={this.onSubmit}
                    isSubmitting={this.state.isSubmitting} />
            </div>
        }
        else {
            content = this.renderQuestionListWithoutModal(formik)
        }
        return content;
    }

    renderDescription = () => {
        return (
            this.props.activityCard!.description && _common.removeHtmlTags(this.props.activityCard!.description).length > 0 ? (
                <React.Fragment>
                    <hr className="bottom-border-2 mx-0 mobile-not-show" />
                    <div className="row ">
                        <div className="col d-flex justify-content-start align-items-baseline mobile-survey-note new-activity-block" >
                            <img src={_common.GetDefaultIcons('infoicon')} className="mr-2" alt="" />
                            <p className="card-info-text card-info-text-width mb-0 mobile-activity-description">
                                <b>{T.t('r_add_exam_teacher_note')}</b>{' '}
                                <span id='instructor_note' className={(!_common.isArabic(this.props.activityCard!.description, document.body.getAttribute('dir')) ? 'arabic-text-direction' : '')} dangerouslySetInnerHTML={{ __html: this.props.activityCard!.description }}>
                                </span>
                            </p>
                        </div>
                    </div>
                </React.Fragment>
            ) : (
                ''
            )
        )
    }

    renderSurveyBody = () => {
        const initialFormValues: IResponseData = {
            userResponses: [],
            isResponded: this.props.activityCard!.surveyInfo ? this.props.activityCard!.surveyInfo.isResponded : false,
            questionIndex: 0
        };

        return (
            <Formik initialValues={initialFormValues} onSubmit={this.onSubmit}>
                {formik => {
                    return (
                        <React.Fragment>
                            <div className="card-body extra-radius">
                                {this.renderSurveyContent(formik)}
                                {this.renderDescription()}
                            </div>
                            {this.renderFooter(formik)}
                        </React.Fragment>
                    );
                }}
            </Formik>
        )
    }

    public render() {
        let isCompletedPrerequisiteActivity: boolean = this.checkPrerequisite();

        return (
            <div className="col-12 mobile-padding card-width">
                <div className={this.props.activityCard!.activeStatus === 0 ? 'card new-activity border-pasif' : 'card new-activity'}>
                    {this.renderCardHeader()}
                    <hr className="bottom-border-2 mobile-not-show" />
                    {!isCompletedPrerequisiteActivity && this.props.activityCard!.prerequisiteActivityId && this.props.userType === UserType.Student ?
                        <div className='row' style={{
                            opacity: 0.5, flexDirection: 'column',
                            fontSize: '1em !important',

                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center',
                        }}>
                            <i className="material-icons" style={{ fontSize: '96px', marginTop: '10px' }}>lock</i>
                            <h5 className="font-medium">
                                {T.t('r_activity_restriction_by_another_message').replace('{0}', this.props.activityCard!.name).replace('{1}', this.props.activityCard!.prerequisiteActivityName)}
                            </h5>
                        </div>
                        :
                        this.renderSurveyBody()
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: ISignleActivityCard): ISignleActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: ISignleActivityCard = Object.assign({}, ownProps, {
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType,
        classId: state.coursePage.coursePageClassId,
        identity: state.login.identitiy,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        enrollmentData: state.enrollment.enrollmentData,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        activityFilters: state.coursePage.activityFilters,
        courseDefaultView: state.coursePage.courseDefaultView,
        sortKey: state.coursePage.courseSortingKey
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.login.identitiy.userType === prev.login.identitiy.userType &&
        next.login.identitiy === prev.login.identitiy &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.profile.userPreferences.preferences === prev.profile.userPreferences.preferences &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.courseDefaultView === prev.coursePage.courseDefaultView

    );
    return ret;
};

const CSurveyActivityCard = connect(mapStateToProps, dispatchProps, null, { areStatesEqual })(SurveyActivityCard);

export default CSurveyActivityCard;
